import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleAdminMedicationConfirm, handleAdminMedicationNeedsMoreInfo } from './actions';
import { IAdminNewMedicationState } from './slice.interface';

const initialState: IAdminNewMedicationState = {};

export const adminNewMedicationSlice = createSlice({
  name: 'admin-new-medication',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleAdminMedicationConfirm.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_CREATE_NEW_MEDICATION_SUCCESS);
      })
      .addCase(handleAdminMedicationNeedsMoreInfo.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_MEDICATION_MARKED_AS_NEEDS_MORE_INFO_SUCCESS);
      });
  },
});

export default adminNewMedicationSlice.reducer;
